import axios from 'axios';
import { toast } from 'react-toastify';
import Config from '../../../../config';
import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';

import {
    CREATE_CUTTING_DC_DETAILS_FAILURE,
    CREATE_CUTTING_DC_DETAILS_REQUEST,
    CREATE_CUTTING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_CUTTING_DC_DETAILS,
    DELETE_CUTTING_DC_DETAILS_FAILURE,
    DELETE_CUTTING_DC_DETAILS_REQUEST,
    DELETE_CUTTING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_CUTTING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_CUTTING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_CUTTING_DC_DETAILS_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_FAILURE,
    FETCH_CUTTING_DC_DETAILS_REQUEST,
    FETCH_CUTTING_DC_DETAILS_SUCCESS,
    CUTTING_DC_DETAILS_USERFORM_RESET,
    UPDATE_CUTTING_DC_DETAILS_FAILURE,
    UPDATE_CUTTING_DC_DETAILS_REQUEST,
    UPDATE_CUTTING_DC_DETAILS_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE,
    FETCH_CUTTING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_CUTTING_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_CUTTING_DC_PREVIOUS_LIST_FAILURE,
    FETCH_CUTTING_DC_DETAILS_DC_NO_REQUEST,
    FETCH_CUTTING_DC_DETAILS_DC_NO_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_DC_NO_FAILURE,
    FETCH_GRN_NO_BY_CUTTING_DC_NO_REQUEST,
    FETCH_GRN_NO_BY_CUTTING_DC_NO_SUCCESS,
    FETCH_GRN_NO_BY_CUTTING_DC_NO_FAILURE,
    FETCH_CUTTING_DC_PROGRAM_REQUEST,
    FETCH_CUTTING_DC_PROGRAM_SUCCESS,
    FETCH_CUTTING_DC_PROGRAM_FAILURE,
    FETCH_CUTTING_DC_DETAIL_STYLE_REQUEST,
    FETCH_CUTTING_DC_DETAIL_STYLE_SUCCESS,
    FETCH_CUTTING_DC_DETAIL_STYLE_FAILURE,
    FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_REQUEST,
    FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_SUCCESS,
    FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_FAILURE,
    CREATE_CUTTING_DC_DETAILS_SKU_STYLE_REQUEST,
    CREATE_CUTTING_DC_DETAILS_SKU_STYLE_SUCCESS,
    CREATE_CUTTING_DC_DETAILS_SKU_STYLE_FAILURE,
    CREATE_CUTTING_DC_DETAILS_GRID_REQUEST,
    CREATE_CUTTING_DC_DETAILS_GRID_SUCCESS,
    CREATE_CUTTING_DC_DETAILS_GRID_FAILURE,
    RESET_CUTTING_DC_DETAIL_GENERATE_SKU,
    FETCH_CUTTING_DC_DETAILS_FORM_REQUEST,
    FETCH_CUTTING_DC_DETAILS_FORM_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_FORM_FAILURE,
    FETCH_CUTTING_DC_DETAILS_SIZE_GRID_REQUEST,
    FETCH_CUTTING_DC_DETAILS_SIZE_GRID_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_SIZE_GRID_FAILURE,
    CUTTING_EDITABLE_QUANTITY_VALUE_REQUEST,
    CUTTING_EDITABLE_QUANTITY_VALUE_SUCCESS,
    CUTTING_EDITABLE_QUANTITY_VALUE_FALIURE,
    CUTTING_EDITABLE_INNER_QUANTITY_VALUE_REQUEST,
    CUTTING_EDITABLE_INNER_QUANTITY_VALUE_SUCCESS,
    CUTTING_EDITABLE_INNER_QUANTITY_VALUE_FALIURE,
    FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_FAILURE,
    FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_REQUEST,
    CUTTING_DC_PROGRAM_ID_FALIURE,
    CUTTING_DC_PROGRAM_ID_SUCCESS,
    CUTTING_DC_PROGRAM_ID_REQUEST,
    CUTTING_DC_DETAILS_DELETE_FABRIC_REQUEST,
    CUTTING_DC_DETAILS_DELETE_FABRIC_SUCCESS,
    CUTTING_DC_DETAILS_DELETE_FABRIC_FAILURE,
    CHECK_ALL_UPDATE_REQUEST,
    CHECK_ALL_UPDATE_SUCCESS,
    CHECK_ALL_UPDATE_FAILURE,
    CUTTING_DC_DETAILS_DELETE_FAILURE,
    CUTTING_DC_DETAILS_DELETE_SUCCESS,
    CUTTING_DC_DETAILS_DELETE_REQUEST,
    RESET_USER_FORM_TO_DEFAULT,
} from './cuttingDcDetails.actionsType';
import Cookies from 'js-cookie';
import { CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE } from '../cuttingDC/cuttingDC.actionsType';
import { LOADING_MODAL_CLOSE } from '../../../actions';
// import { CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE } from '../cuttingDC/cuttingDc.actionsType';

// FETCH PROPERTY MASTER
// export let fetchCuttingDCDetailsById = (id) => {
//     let config = {
//         method: 'get',
//         url: `${ConstantApi.cuttingDcDetailsGET_BY_ID}?FldFkDCNO=${id}`,
//         responseTypeRequest: FETCH_CUTTING_DC_DETAILS_BY_ID_REQUEST,
//         responseTypeSuccess: FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS,
//         responseTypeFailure: FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE
//     };
//     return axiosCall(config);
// };
//sagar told to change this api
export let fetchCuttingDCDetailsById = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDcDetailsGET_BY_ID}?FldId=${id}`,
        responseTypeRequest: FETCH_CUTTING_DC_DETAILS_BY_ID_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE
    };
    return axiosCall(config);
};

export let fetchCuttingDCDetailsInnerGrid = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDcDetailsGET_BY_ID_INNER}/${id}`,
        responseTypeRequest: FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_FAILURE
    };
    return axiosCall(config);
};

// FETCH PROPERTY MASTER
export let fetchCuttingDCDetailsFormDataById = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDCDetailsFormDataGET_BY_ID}/${id}`,
        responseTypeRequest: FETCH_CUTTING_DC_DETAILS_FORM_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_DETAILS_FORM_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_DETAILS_FORM_FAILURE
    };
    return axiosCall(config);
};

// FETCH PROPERTY MASTER
export let fetchCuttingDCDetails = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDcDetailsGET}`,
        responseTypeRequest: FETCH_CUTTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_DETAILS_FAILURE
    };
    return axiosCall(config);
};

export let fetchCuttingDCDetailsLoadGridWithSize = (id, dcNo) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDcDetailsSizeGrid}?FldSalesOrderDetailId=${id}&DCNO=${dcNo}`,
        responseTypeRequest: FETCH_CUTTING_DC_DETAILS_SIZE_GRID_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_DETAILS_SIZE_GRID_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_DETAILS_SIZE_GRID_FAILURE
    };
    return axiosCall(config);
};

export const deleteFabricDelete = (id, detailsId, fldFKStyle, fldFKProgram, salesId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.cuttingDCFabricDelete}/${id}`,
        responseTypeRequest: CUTTING_DC_DETAILS_DELETE_FABRIC_REQUEST,
        responseTypeSuccess: CUTTING_DC_DETAILS_DELETE_FABRIC_SUCCESS,
        responseTypeFailure: CUTTING_DC_DETAILS_DELETE_FABRIC_FAILURE,
        // getAllData: fetchCuttingDCDetailsInnerGrid(detailsId),
        singlApiArray: [
            fetchCuttingDCPreviousGetList(fldFKStyle, 0, fldFKProgram, salesId),
            fetchCuttingDCDetailsInnerGrid(detailsId),
        ]
    };
    return axiosCall(config);
};

// create user Form
export let createCuttingDCDetailsUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_CUTTING_DC_DETAILS, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createCuttingDCDetails = (formData, modalClose, isStatus, parentId, fldFkProgramId, detailsId, styleId, cuttingDCSelectedValue) => {
    // console.log('formData', formData)
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        // ...formData,
        fldFKDCNo: parseInt(formData.fldFKDCNo),
        FldReason: '',
        FldFKPreviousDCPO: parseInt(formData.FldFKPreviousDCPO),
        FldPreviousDCPO: formData.FldPreviousDCPO,
        FldFKProgram: parseInt(formData.FldFKProgram),
        FldProgram: formData.FldProgram,
        FldInwardId: formData.FldInwardId,
        fldFKSizeInfo: 0,
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldFKStyleDetail: parseInt(formData.fldFKStyleDetail),
        //fldFKStyleDetail: 73,
        fldStyleNumber: formData?.fldStyleNumber,
        fldSalesOrderNo: formData?.fldSalesOrderNo,
        fldFKColour: parseInt(formData.fldFKColour),
        FldColour: formData.FldColour,
        fldColourShade: formData.FldColour,
        fldFKFabric: parseInt(formData.fldFKFabric),
        // fldFKProgram: parseInt(formData.fldFKProgram),
        fldFabric: formData?.fldFabric,
        fldFKFabricGroup: parseInt(formData.fldFKFabricGroup),
        fldFabricGroup: formData?.fldFabricGroup,
        fldFKFabricMaster: parseInt(formData.fldFKFabricMaster),
        fldFKSaleOrderDetail: parseInt(formData.fldFKSaleOrderDetail),
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        // fldFabricMaster: formData?.fldFabricMaster,
        // // fldYarnCounts: formData?.fldYarnCounts,
        fldRate: formData?.fldRate ? Number(formData?.fldRate) : 0,
        fldCBM: formData?.fldCBM ? Number(formData?.fldCBM) : 0,
        fldQuantity: formData.fldQuantity ? Number(formData.fldQuantity) : 0,
        fldGrossValue: formData.fldGrossValue ? Number(formData.fldGrossValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldTaxableValue: formData.fldTaxableValue ? Number(formData.fldTaxableValue) : 0,
        fldIGSTPercentage: formData.fldIGSTPercentage ? Number(formData.fldIGSTPercentage) : 0,
        fldIGSTValue: formData.fldIGSTValue ? Number(formData.fldIGSTValue) : 0,
        fldSGSTPercentage: formData.fldSGSTPercentage ? Number(formData.fldSGSTPercentage) : 0,
        fldSGSTValue: formData.fldSGSTValue ? Number(formData.fldSGSTValue) : 0,
        fldCGSTPercentage: formData.fldCGSTPercentage ? Number(formData.fldCGSTPercentage) : 0,
        fldCGSTValue: formData.fldCGSTValue ? Number(formData.fldCGSTValue) : 0,
        fldGSTValue: formData.fldGSTValue ? Number(formData.fldGSTValue) : 0,
        fldTotalValue: formData.fldTotalValue ? Number(formData.fldTotalValue) : 0,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData?.ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: 0,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKUOM: parseInt(formData.fldFKUOM),
        fldFKDia: parseInt(formData.fldFKDia),
        fldDia: formData?.fldDia,
        fldFinishingGSM: formData?.fldFinishingGSM ? formData?.fldFinishingGSM : 0,
        fldFKNeckType: formData.fldFKNeckType ? parseInt(formData.fldFKNeckType) : 1,
        fldFKPartColour: formData.fldFKPartColour ? parseInt(formData.fldFKPartColour) : 1,
        fldFKPrintType: formData.fldFKPrintType ? parseInt(formData.fldFKPrintType) : 1,
        fldFKCatalogue: formData.FldFKCatalogue ? parseInt(formData.FldFKCatalogue) : 1,
        fldFKChest: formData.fldFKChest ? parseInt(formData.fldFKChest) : 1,
        fldFKSleevetype: formData?.fldFKSleevetype ? parseInt(formData.fldFKSleevetype) : 1,
        fldFKFabricOrCompactingPO: formData.fldFKFabricOrCompactingPO ? parseInt(formData.fldFKFabricOrCompactingPO) : 0,
        fldFKStylePartColor: formData.fldFKStylePartColor ? parseInt(formData.fldFKStylePartColor) : 1,
        fldLotNo: formData?.fldLotNo ? formData?.fldLotNo : '',
        fldPartName: formData?.fldPartName ? formData?.fldPartName : '',
        fldFKRatePerPCs: Number(formData.fldFKRatePerPCs),
        fldFKLength: formData.fldFKLength ? Number(formData.fldFKLength) : 0,
        fldNoofboxes: formData.fldNoofboxes ? Number(formData.fldNoofboxes) : 0,
        // fldFKGSM: Number(formData.fldFKGSM),
        // fldLoopLength: formData.fldLoopLength,
        // fldFKRatePerKG: formData.fldFKRatePerKG ? Number(formData.fldFKRatePerKG) : 0,

        fldFKNoofRolls: formData?.fldReceivingRolls ? Number(formData?.fldReceivingRolls) : 0,
        // fldFKNoofBags: parseInt(formData.fldFKNoofBags),
        fldFKWeightinKg: formData.fldQuantity ? Number(formData.fldQuantity) : 0,
        fldInwardQuantity: formData?.fldInwardQuantity ? Number(formData?.fldInwardQuantity) : 0,
        fldCancelQuantity: formData?.fldCancelQuantity ? Number(formData?.fldCancelQuantity) : 0,
        fldBalanceQuantity: formData?.fldBalanceQuantity ? Number(formData?.fldBalanceQuantity) : 0,
        fldFKTypeoffit: 1,
        fldTypeoffit: 'string'
    });
    // let config = {
    //     method: 'post',
    //     data,
    //     url: `${ConstantApi.cuttingDCDetailsPOST}?FldInwardId=${(formData?.InwardNO).toString()}`, //
    //     responseTypeRequest: CREATE_CUTTING_DC_DETAILS_REQUEST,
    //     responseTypeSuccess: CREATE_CUTTING_DC_DETAILS_SUCCESS,
    //     responseTypeFailure: CREATE_CUTTING_DC_DETAILS_FAILURE,
    //     resetFormData: isStatus ? CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE : CUTTING_DC_DETAILS_USERFORM_RESET,
    //     modalClose,
    //     headers: {
    //         'Content-Type': 'application/json'
    //     },
    //     getAllData: fetchCuttingDCDetailsById(parentId)
    // };
    // return axiosCall(config);
    return (dispatch) => {
        dispatch({ type: CREATE_CUTTING_DC_DETAILS_REQUEST });
        var config = {
            method: 'post',
            url: `${Config.baseUrl}${ConstantApi.cuttingDcDetailsPOST}?FldInwardId=${formData?.FldInwardId}&ProgramId=${formData?.ProgramMappingId}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            },
            data
        };
        axios(config)
            .then((response) => {
                dispatch({ type: CREATE_CUTTING_DC_DETAILS_SUCCESS, payload: response.data });
                dispatch(fetchCuttingDCDetailsById(parentId));
                dispatch(fetchCuttingDCDetailsInnerGrid(parentId));
                dispatch(fetchCuttingDCPreviousGetList(detailsId[0]?.fldID ? detailsId[0]?.fldFKStyle : styleId, 0, fldFkProgramId, detailsId?.length ? detailsId[0]?.fldFKSaleOrder : cuttingDCSelectedValue?.fldFKSaleOrder));
                toast.success('Data created successfully', { autoClose: 1500 });
                dispatch({ type: RESET_USER_FORM_TO_DEFAULT })

                // if (response?.data.length > 0) {
                //     dispatch(
                //         createCuttingDCDetailGridMaster(
                //             gridData,
                //             parentId,
                //             response?.data[0]?.fldId,
                //             response?.data[0]?.fldInwardId,
                //             isStatus,
                //             modalClose
                //         )
                //     );
                // }
            })
            .catch((error) => {
                dispatch({ type: LOADING_MODAL_CLOSE });
                toast.error('Internal Server Error')
                dispatch({ type: CREATE_CUTTING_DC_DETAILS_FAILURE, payload: error });
            });
    };
};

export let createCuttingDCDetailGridMaster = (formData, parentId, dcNo, inwardId, isStatus, modalClose) => {
    let config = {
        method: 'post',
        data: JSON.stringify(formData),
        url: `${ConstantApi.cuttingDCDetailsGridPOST}?FldFKDC=${dcNo}&FldInwardId=${inwardId}`,
        responseTypeRequest: CREATE_CUTTING_DC_DETAILS_GRID_REQUEST,
        responseTypeSuccess: CREATE_CUTTING_DC_DETAILS_GRID_SUCCESS,
        responseTypeFailure: CREATE_CUTTING_DC_DETAILS_GRID_FAILURE,
        resetFormData: isStatus ? CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE : CUTTING_DC_DETAILS_USERFORM_RESET,
        modalClose: modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchCuttingDCDetailsById(parentId)
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleCuttingDCDetails = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDCDetailsGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_CUTTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_CUTTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_CUTTING_DC_DETAILS_FAILURE,
        singlApiArray: []
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateCuttingDCDetails = (formData, id, parentId) => {
    let today = new Date();
    let data = JSON.stringify({
        ...formData,
        fldId: parseInt(id),
        fldFKDCNo: parseInt(formData.fldFKDCNo),
        fldFKSizeInfo: 0,
        fldFKSKUDetail: 0,
        fldSKUDetail: '',
        fldFKStyle: parseInt(formData.fldFKStyle),
        fldStyleNumber: formData?.fldStyleNumber,
        fldFKColour: 0,
        fldColourShade: formData.FldColour,
        fldFKFabric: parseInt(formData.fldFKFabric),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldFabric: formData?.fldFabric,
        fldFKFabricGroup: parseInt(formData.fldFKFabricGroup),
        fldFabricGroup: formData?.fldFabricGroup,
        fldFKFabricMaster: parseInt(formData.fldFKFabricMaster),
        fldFinishingGSM: '',
        // fldFabricMaster: formData?.fldFabricMaster,
        // // fldYarnCounts: formData?.fldYarnCounts,
        fldRate: formData?.fldRate ? Number(formData?.fldRate) : 0,
        fldCBM: formData?.fldCBM ? Number(formData?.fldCBM) : 0,
        fldQuantity: formData.fldQuantity ? Number(formData.fldQuantity) : 0,
        fldGrossValue: formData.fldGrossValue ? Number(formData.fldGrossValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldTaxableValue: formData.fldTaxableValue ? Number(formData.fldTaxableValue) : 0,
        fldIGSTPercentage: formData.fldIGSTPercentage ? Number(formData.fldIGSTPercentage) : 0,
        fldIGSTValue: formData.fldIGSTValue ? Number(formData.fldIGSTValue) : 0,
        fldSGSTPercentage: formData.fldSGSTPercentage ? Number(formData.fldSGSTPercentage) : 0,
        fldSGSTValue: formData.fldSGSTValue ? Number(formData.fldSGSTValue) : 0,
        fldCGSTPercentage: formData.fldCGSTPercentage ? Number(formData.fldCGSTPercentage) : 0,
        fldCGSTValue: formData.fldCGSTValue ? Number(formData.fldCGSTValue) : 0,
        fldGSTValue: formData.fldGSTValue ? Number(formData.fldGSTValue) : 0,
        fldTotalValue: formData.fldTotalValue ? Number(formData.fldTotalValue) : 0,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData?.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: formData?.fldCreatedDt,
        fldModifiedBy: 11,
        fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        fldDeletedDt: today.toISOString(),
        fldFKStatus: 1317,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKUOM: parseInt(formData.fldFKUOM),
        fldFKDia: parseInt(formData.fldFKDia),
        fldDia: formData?.fldDia,
        fldFinishingGSM: formData?.fldFinishingGSM ? formData?.fldFinishingGSM : 0,
        fldFKNeckType: formData.fldFKNeckType ? parseInt(formData.fldFKNeckType) : 0,
        fldFKPartColour: formData.fldFKPartColour ? parseInt(formData.fldFKPartColour) : 0,
        fldFKPrintType: formData.fldFKPrintType ? parseInt(formData.fldFKPrintType) : 0,
        fldFKCatalogue: formData.FldFKCatalogue ? parseInt(formData.FldFKCatalogue) : 0,
        fldFKChest: formData.fldFKChest ? parseInt(formData.fldFKChest) : 0,
        fldFKSleevetype: formData?.fldFKSleevetype ? parseInt(formData.fldFKSleevetype) : 0,
        fldFKFabricOrCompactingPO: formData.fldFKFabricOrCompactingPO ? parseInt(formData.fldFKFabricOrCompactingPO) : 0,
        fldFKStylePartColor: formData.fldFKStylePartColor ? parseInt(formData.fldFKStylePartColor) : 0,
        fldLotNo: formData?.fldLotNo ? formData?.fldLotNo : '',
        fldPartName: formData?.fldPartName ? formData?.fldPartName : '',
        fldFKRatePerPCs: Number(formData.fldFKRatePerPCs),
        fldFKLength: formData.fldFKLength ? Number(formData.fldFKLength) : 0,
        fldNoofboxes: formData.fldNoofboxes ? Number(formData.fldNoofboxes) : 0,
        // fldFKGSM: Number(formData.fldFKGSM),
        // fldLoopLength: formData.fldLoopLength,
        // fldFKRatePerKG: formData.fldFKRatePerKG ? Number(formData.fldFKRatePerKG) : 0,
        fldFKNoofRolls: formData?.fldFKNoofRolls ? Number(formData?.fldFKNoofRolls) : 0,
        // fldFKNoofBags: parseInt(formData.fldFKNoofBags),
        fldFKWeightinKg: formData.fldFKWeightinKg ? Number(formData.fldFKWeightinKg) : 0,
        fldInwardQuantity: formData?.fldInwardQuantity ? Number(formData?.fldInwardQuantity) : 0,
        fldCancelQuantity: formData?.fldCancelQuantity ? Number(formData?.fldCancelQuantity) : 0,
        fldBalanceQuantity: formData?.fldBalanceQuantity ? Number(formData?.fldBalanceQuantity) : 0
    });

    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.cuttingDCDetailsPATCH}/${id}`,
        responseTypeRequest: UPDATE_CUTTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: UPDATE_CUTTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: UPDATE_CUTTING_DC_DETAILS_FAILURE,
        resetFormData: CUTTING_DC_DETAILS_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchCuttingDCDetailsById(parentId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteCuttingDCDetails = (id, parentId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.cuttingDCDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_CUTTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: DELETE_CUTTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: DELETE_CUTTING_DC_DETAILS_FAILURE,
        modalClose: true,
        getAllData: fetchCuttingDCDetailsById(parentId)
    };
    return axiosCall(config);
};

export let fetchCuttingDCPreviousGetList = (style, id, programID, salesId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDcDetailsPreviousGetList}?FldFKStyleId=${style}&FldFKStyleDetailId=${programID}&FldFkProgramCode=CUD&IsUpdated=${id}&FldFKSaleOrder=${salesId}`,
        responseTypeRequest: FETCH_CUTTING_DC_PREVIOUS_LIST_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_PREVIOUS_LIST_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_PREVIOUS_LIST_FAILURE
    };
    return axiosCall(config);
};

// FETCH PROPERTY MASTER
export let fetchCuttingDCNoInCutting = (programNo, styleNo) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDcDetailsDCNoGET}?FldFKProgram=${programNo}&FldFKStyle=${styleNo}`,
        responseTypeRequest: FETCH_CUTTING_DC_DETAILS_DC_NO_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_DETAILS_DC_NO_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_DETAILS_DC_NO_FAILURE
    };
    return axiosCall(config);
};

export let fetchGRNNoByCuttingDcNo = (DcNo) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.GRNNoByCuttingDCNoGET}?FldPONO=${DcNo}`,
        responseTypeRequest: FETCH_GRN_NO_BY_CUTTING_DC_NO_REQUEST,
        responseTypeSuccess: FETCH_GRN_NO_BY_CUTTING_DC_NO_SUCCESS,
        responseTypeFailure: FETCH_GRN_NO_BY_CUTTING_DC_NO_FAILURE
    };
    return axiosCall(config);
};

export let fetchCuttingDCProgramGetList = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDcDetailsProgramGetListGET}`,
        responseTypeRequest: FETCH_CUTTING_DC_PROGRAM_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_PROGRAM_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_PROGRAM_FAILURE
    };
    return axiosCall(config);
};

export let fetchCuttingDCDetailStyleGetList = (programId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDcDetailsStyleGetListGET}?FldFKProgram=${programId}`,
        responseTypeRequest: FETCH_CUTTING_DC_DETAIL_STYLE_REQUEST,
        responseTypeSuccess: FETCH_CUTTING_DC_DETAIL_STYLE_SUCCESS,
        responseTypeFailure: FETCH_CUTTING_DC_DETAIL_STYLE_FAILURE
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getGenerateCuttingDCDetailsSKUStyle = (styleId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDCDetailsGenerateSKUStyleGET}?FldFKStyle=${styleId}`,
        responseTypeRequest: FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_FAILURE,
        singlApiArray: []
    };
    return axiosCall(config);
};

export let saveCuttingDCDetails = (jsonData, modalClose, isStatus, parentId, formData, loaderModal) => {
    let FldFKHSNCode = parseInt(formData.FldFKHSNCode || 0);
    let FldFKCatalogue = parseInt(formData.FldFKCatalogue || 0);
    let FldFKPreviousDCPO = parseInt(formData.FldFKPreviousDCPO || 0);
    let FldPreviousDCPO = formData.FldPreviousDCPO || '';
    let FldFKProgram = parseInt(formData.FldFKProgram || 0);
    let FldFKDCDetailNo = 0;

    let today = new Date();
    let config = {
        method: 'post',
        data: JSON.stringify(jsonData),
        url: `${ConstantApi.saveCuttingDcDetailsPOST}?FldFKDC=${parentId}&FldGrossValue=${formData.fldGrossValue}&FldDiscountPercentage=${formData.fldDiscountPercentage
            }&FldDiscountValue=${formData.fldDiscountValue}&FldTaxableValue=${formData.fldTaxableValue || 0}&FldIGSTPercentage=${formData.fldIGSTPercentage
            }&FldIGSTValue=${formData.fldIGSTValue}&FldSGSTPercentage=${formData.fldSGSTPercentage || 0}&FldSGSTValue=${formData.fldSGSTValue || 0
            }&FldCGSTPercentage=${formData.fldCGSTPercentage || 0}&FldCGSTValue=${formData.fldCGSTValue || 0}&FldGSTValue=${formData.fldGSTValue || 0
            }&FldTotalValue=${formData.fldTotalValue || 0
            }&FldFKHSNCode=${FldFKHSNCode}&FldFKCatalogue=${FldFKCatalogue}&FldFKPreviousDCPO=${1}&FldPreviousDCPO=${'1'}&FldFKProgram=${1}&FldProgram=${'1'}&FldFKDCDetailNo=${FldFKDCDetailNo}`,
        responseTypeRequest: CREATE_CUTTING_DC_DETAILS_SKU_STYLE_REQUEST,
        responseTypeSuccess: CREATE_CUTTING_DC_DETAILS_SKU_STYLE_SUCCESS,
        responseTypeFailure: CREATE_CUTTING_DC_DETAILS_SKU_STYLE_FAILURE,
        resetFormData: isStatus ? CUTTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE : CUTTING_DC_DETAILS_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        singlApiArray: [{ type: RESET_CUTTING_DC_DETAIL_GENERATE_SKU }],
        getAllData: fetchCuttingDCDetailsById(parentId)
    };
    return axiosCall(config, false, true);
};

export function getCuttingQty(dc, salesId, size, FldPartId, colorId, dcNo) {


    let config = {
        method: 'get',
        // url: `${ConstantApi.cuttingDCQty}?FldFkDCNO=${dc}&SaleOrderId=${salesId}&FldUniqueId=${unqiqueId}&FldSize=${size}&FldPartId=${partId}&FldPartcolorId=${colorId}`,

        url: `${ConstantApi.cuttingDCQty}?FldFKStyle=${dc}&SaleOrderId=${salesId}&FldSize=${size}&FldDCNo=${dcNo}`,
        responseTypeRequest: CUTTING_EDITABLE_QUANTITY_VALUE_REQUEST,
        responseTypeSuccess: CUTTING_EDITABLE_QUANTITY_VALUE_SUCCESS,
        responseTypeFailure: CUTTING_EDITABLE_QUANTITY_VALUE_FALIURE
    };
    return axiosCall(config);
}

export function getQtyInner(dc, salesId, unqiqueId, size, partId) {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingqtyInnerApi}?FldFKStyle=${dc}&SaleOrderId=${salesId}&FldUniqueId=${unqiqueId}&FldSize=${size}&FldPartId=${partId}`,
        responseTypeRequest: CUTTING_EDITABLE_INNER_QUANTITY_VALUE_REQUEST,
        responseTypeSuccess: CUTTING_EDITABLE_INNER_QUANTITY_VALUE_SUCCESS,
        responseTypeFailure: CUTTING_EDITABLE_INNER_QUANTITY_VALUE_FALIURE
    };
    return axiosCall(config);
}


export let getStyleProgramId = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.cuttingDCMasterGETID}/${id}`,
        responseTypeRequest: CUTTING_DC_PROGRAM_ID_REQUEST,
        responseTypeSuccess: CUTTING_DC_PROGRAM_ID_SUCCESS,
        responseTypeFailure: CUTTING_DC_PROGRAM_ID_FALIURE
    };
    return axiosCall(config);
};

export let getDeleteDCDetails = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.deleteDCDetails}/${id}`,
        responseTypeRequest: CUTTING_DC_DETAILS_DELETE_REQUEST,
        responseTypeSuccess: CUTTING_DC_DETAILS_DELETE_SUCCESS,
        responseTypeFailure: CUTTING_DC_DETAILS_DELETE_FAILURE
    };
    return axiosCall(config);
};




export let updateCheckAllCutting = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.updateAllCloseIconCutting}?FldFKPoNo=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CHECK_ALL_UPDATE_REQUEST,
        responseTypeSuccess: CHECK_ALL_UPDATE_SUCCESS,
        responseTypeFailure: CHECK_ALL_UPDATE_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};